<template>
  <el-dialog
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    style="margin-top: 13%"
    width="400px"
  >
    <span slot="title" style="text-align: left; float: left; font-weight: 10px; font-size: 18px">
      Antenção
    </span>
    <el-form size="small" label-position="top">
      <el-row :gutter="10">
        <el-col :span="2" style="width: 30px">
          <i class="el-icon-warning" style="color: orange; font-size: 25px;"/>
        </el-col>
        <el-col :span="21" style="margin: 5px 0px 0px 0px">
          <span>Preencha todos os campos obrigatórios</span>
          <div style="font-weight: normal; font-size: 13px; margin-top: 6px" v-if="formValidacao.endereco == ''">- Endereço</div>
          <div style="font-weight: normal; font-size: 13px" v-if="formValidacao.numeroEndereco == ''">- Número</div>
          <div style="font-weight: normal; font-size: 13px" v-if="formValidacao.cep == ''">- CEP</div>
          <div style="font-weight: normal; font-size: 13px" v-if="formValidacao.nomeRepresentante == ''">- Representante</div>
          <div style="font-weight: normal; font-size: 13px" v-if="formValidacao.cargoRepresentante == ''">- Cargo</div>
          <div style="font-weight: normal; font-size: 13px" v-if="formValidacao.cpfRepresentante == ''">- CPF</div>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button @click="fechar" size="small" type="primary">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visibility: Boolean,
    formValidacao: Object
  },

  methods: {
    fechar() {
      this.$emit("close");
    },
  },
}
</script>